import { connect } from 'react-redux';
import { get } from 'lodash';

import FoodProfileInfo from '../components/FoodProfileInfo';

export default connect(
  (state, ownProps) => {
    const suitability = get(state, ['foodProfile', 'productsSuitability', ownProps.barcode]);

    return {
      isBadgeEnabled: state.foodProfile.isBadgeEnabled,
      suitability,
    };
  })(FoodProfileInfo);
